import Chart from 'chart.js';

const config = {
    type: 'pie',
    options: {
        cutoutPercentage: 40,
        responsive: false,
        hover: {
            mode: null,
        },
        legend: {
            display: false,
        },
        tooltips: {
            enabled: false,
        },
        animation: {
            onComplete() {
                this.canvas.nextElementSibling.setAttribute('src', this.toBase64Image());
            },
        },
    },
};

export default (() => {
    const charts = Array.from(document.querySelectorAll('.js-pie-stats'));

    charts.forEach((canvas) => {
        const ctx = canvas.getContext('2d');
        const value = canvas.dataset.stat;

        const data = {
            datasets: [{
                data: [value, 100 - value],
                backgroundColor: ['rgb(97,147,206)', 'rgb(221,221,221)'],
            }],
        };

        new Chart(ctx, { ...config, data });
    });
})();
